const toHankaku = (str) => str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
  return String.fromCharCode(s.charCodeAt(0) - 65248);
});

const toZenkaku = (str) => str.replace(/[A-Za-z0-9]/g, function(s) {
  return String.fromCharCode(s.charCodeAt(0) + 65248);
});

// eslint-disable-next-line import/no-anonymous-default-export
export default {toHankaku, toZenkaku};